module.exports = __webpack_public_path__ + "img/greece.67ac71c3.svg";